import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_QUICK_SUPPORT_QUESTION_ANSWER_DETAIL,
    getQuickSupportQuestionAnswerDetailFail,
    getQuickSupportQuestionAnswerDetailSuccess
} from '../action/getQuickSupportQuestionAnswerDetailAction'

// api 
import getQuickSupportQuestionAnswerDetailApi from '../api/getQuickSupportQuestionAnswerDetailApi'

export function* getQuickSupportQuestionAnswerDetailSaga(action) {
    try {
        const response = yield call(() => getQuickSupportQuestionAnswerDetailApi(action.params))
        if (response.data.status === 1) {
            yield put(getQuickSupportQuestionAnswerDetailSuccess(response, action))
        } else {
            yield put(getQuickSupportQuestionAnswerDetailFail(response, action))
        }
    }
    catch (e) {
        yield put(getQuickSupportQuestionAnswerDetailFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_QUICK_SUPPORT_QUESTION_ANSWER_DETAIL, getQuickSupportQuestionAnswerDetailSaga)
}